// extracted by mini-css-extract-plugin
export default {"products":"xt-z","card":"yt-z","oosMessaging":"zt-z"};